;(function (window) {

	var AjaxErrorHandlerManager = (function(){

		function extend(obj1, obj2){
		    var obj = {};
		    for (var key in obj1) { obj[key] = obj1[key]; }
		    for (var key in obj2) { obj[key] = obj2[key]; }
		    return obj;
		}

		function callErrorsCallback(error, val){
			var callback = this.opts[error.code];
			if(typeof callback === 'function'){
				return callback();
			}
		}

		function isResponseError(resp){
			return Boolean(resp !== undefined && Number(resp) === 0);
		}

		var methods = Object.create(null);
		methods.opts = {};

		methods.onErrorCode = function(options){
			this.opts = extend(this.opts, options);
		};

		methods.responseCheck = function(event, xhr, settings){
			if(xhr.status !== 200){
				return false;
			}

			var
				resp = xhr.responseJSON,
				is_errors = isResponseError(resp.success),
				errors = resp.errors
			;

			is_errors && errors && errors.every(callErrorsCallback.bind(methods));
		};

		return methods;
	}());

	window.AjaxErrorHandlerManager = AjaxErrorHandlerManager;

}(window));